import React from 'react';
import PropTypes from 'prop-types';
import {shuffle} from './global';
import Map from './Map';
import AnswerButton from './AnswerButton';
import FlipMove from 'react-flip-move';

const time = 1000;

class GameSurface extends React.Component {   

    constructor(props){
        super(props);
        this.resetGame = this.resetGame.bind(this);
        this.startGame = this.startGame.bind(this);
        this.loadState = this.loadState.bind(this);
        this.makeChoice = this.makeChoice.bind(this);
        this.state = {
            states : [],
            currentIndex : 0,
            selected : null,
            options : [],
            incorrect : [],
            answering : false,
            loopId : 'asdasd'
        }
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    loadState(states, idx){
        let selected = {...states[idx]};
        let options = selected.options.slice();
        options =  shuffle(options); //shuffle the order of the array
        options = options.slice(0,3); //take the first 3
        options.push(selected.correct); //add the correct answer;
        selected.options = shuffle(options); //shuffle the order
        return selected;
    }
    startGame(){
        let states = JSON.parse(JSON.stringify(this.props.data.states)); // deep copy the input data

        // states = [
        //     {
        //         state : "Texas",
        //         correct : "Austin",
        //         options : [
        //             "Houston", "Dallas", "San Antonio", "El Paso", "Fort Worth", "Waco"
        //         ],
        //         path : "M527.43,288.76v-.05c.33-2.35,1.87-5,.56-7.3-.62-1.09-2.64-2-3.5-3-2.55-3-2-7.31-4.31-10.28-2.09-2.63-4.35-4.88-4.5-8.47-.19-4.66-1-7.61-4-11-1.43-1.68-3.72-2.57-4.72-4.62-1.17-2.4-.44-5.39-.62-8-.65-9.44-.54-19.17-.83-28.73-.27-8.66-1-17.61-.4-26.25a46.17,46.17,0,0,0-.23-8.23c-.07-.56-4.26-.91-4.81-1-2.45-.21-4.62,1.43-7.06.68-1.82-.55-2.58-3.09-4.07-3.4-8.11-1.7-14.44-5.14-21-9.69-1.32-.95-2.48-2.25-3.87-3.08-2.21-1.33-4.3,2.58-6.51,3.3-3.45,1.11-7-.47-9.58-2.74-.16-.13-4.75,2.67-5.24,2.87-2.94,1.21-5.9,1.24-8.53-.63l-.16.1c-2.18,1.3-4.23,2.58-6.32,4s-6.71,5.73-9.43,3.62a46.67,46.67,0,0,0-6-4.15c-.86-.47-4.9-2.47-4.72-3.81v0c-.8,2.48-6.33,2.27-8.05,1.19-1.32-.83-2-2.67-3.21-3.37h0c-.51.06-1.71,1.65-2.28,3.15-1,2.62-1.37,6.63-4.86,7.12-3.18.44-5.09-3.58-5.13-6.22l-.18,0c-1.64.33-3.14.66-3.58.74-3.53.66-5.32-1.4-8.1-3-1.19-.69-2.18-2.84-3.58-3-.74-.1-2,1.62-2.52,2.1-1.68,1.62-3.48,3.23-6,3.29-4.5.11-4.93-4.23-4.85-7.54a13.8,13.8,0,0,1-2.26-.8,5.85,5.85,0,0,1-2.79-5.44c-4,.31-7.66,2.38-11.72,2.49-3.64.1-5.52-3.19-8.8-3.49a55,55,0,0,1-9.07-1.81c-2.63-.71-5.25-.8-7.87-1.44-4-1.36-5-6.56-7.66-9.42-2.55,1.56-6.28.56-9.13.65s-5.84-.08-7.83-2.59c-1.06-1.33-1.8-3-3.08-4.1-1.45-1.28-3.13-1-4.81-1.75-2.12-1-2.4-2.8-2.54-4.91,0-6.71.63-13.5.85-20.22.44-13.69,1.4-27.27,1.68-40.83.16-7.78.53-15.64.42-23.42-2.35-.63-4-1.35-6.5-1.35-15.71,0-31.55-.53-47.24-1.38-3.82-.21-49.1-2.55-53.38-2.87,0,.28-12.46,185.1-12.74,191.15-.19,4.14-.47,8.25-.85,12.39-2,8.33-15.74,4.75-21.53,4.18-4.82-.47-88-7.31-109.87-9.12,1.6,2.72,1.76,5.78,3.83,8.79,2.69,3.89,6.52,4.72,10,7.76,10.14,8.84,16,21.32,27.3,29.2a31.29,31.29,0,0,1,8.8,9.07c7.31,11.17,6.54,21.61,9.66,33.62,2,7.52,5.59,12.45,11,17.4,10,9.19,20.29,13.85,31.2,20.89,10.45,6.76,15.38,11.56,23-.57,5.68-9,9.06-21.11,19.54-25.92,7.95-3.66,10-2.14,17.74-.54,14.55,3,23.74-4.21,31.38,11.7a24.71,24.71,0,0,0,2.83-.52c2.9,9,15.2,13.4,19.94,22.62,4.88,9.49,7.3,19.86,13.91,28.73,1.95,2.6,1.53,7,3,9.95,2.21,4.49,6.05,7.56,9.23,11.34,2.84,3.4,4.54,7.83,7,11.54,4.9,7.41,20.22,12.33,12.54,23.86,4.12,2,3.42,10.09,5.25,14.25,4,9,8.16,23.51,16.12,29.25,7.23,5.22,17.22,5.45,25.11,9.54,6.85,3.55,14.29,2.79,21.34,5.27,5.68,2,11.4,8.93,17.6,9,2.8,0,11.32-3.71,11.82-7.25-2.77,1.6-4.85,1.89-6.16-1.13,3.69-4.32-3.8-14.5-5.06-20.38-.72-3.33.22-7.34-1.1-10.53-1.13-2.73-4.84-4.37-3.95-7.74a6.47,6.47,0,0,0,1.88.61c-.81-1.46-2.78-3.53-2-5.68.34-1,2.47.14,3-.62a14,14,0,0,0,1.27-3.79c.65-2.66.18-5.32,1.29-7.91-4.94,1.25-6.77,1.13-11.68-.28.16.05-1-5.68-1.07-6.09,1,.83,2.55,2.58,3.9,3.05,2.24.78,4.53-.56,6.82,0-.67.6-1.32,1.71-2.12,2.21a20.18,20.18,0,0,1,4.2-1.43c.85-.29,1.85-2.21,2.75-4.67-.88,3.18.08,6.4-.8,9.56,2.47-8.81,6.31-16.4,10.84-24.27v-3.13c0,3.07-2.51,5.69-4.26,8-1.93,2.5-4.29,5.4-5.29,8.44,1.47-4.47,2.51-9.94,2-11.22-.76-1.73-5.2-3.92-3.93-6.32-.66,1.22-2.44.43-3-.23,2.79-3.11,8.43-1.62,10.83,1.35,1.74-2.42,4.21-4.34,5.73-6.93,1.16-2,.77-4.65,1.67-6.74-.18.4-5,4.23-4.29,4.74a24.71,24.71,0,0,1-2.82-2.5,6.81,6.81,0,0,0,1.41-4c.07.51,5.87-2.34,6.31.95,0-.4,3.27-4.44,3.64-5.28a9.22,9.22,0,0,1-.78,5.19c.43-1,2.7-1.54,3.52-2.29,2.85-2.63,2.68-4.51,1.8-8-.45-1.78,1.44-3.44.44-5.19,1.55,2.18,2.93,5.87,5.86,6.33,2.16.35,4.28-.82,6-1.94.31-.2,4.78-3.32,4.27-3.63-2.44-1.47-3.2-1.63-6-.87.57-.95,1.13-1.9,1.7-2.84a14.57,14.57,0,0,1-5.64-7.87,14,14,0,0,1,2.79-.42c.87,3.36,4.48,6.19,8,4.55a32.29,32.29,0,0,1-2.47-5.64c1.28,1.1,2.92,4.1,4.85,4.14,1.08,0,2.27-1.84,3.16-1.59s1,1.91,1.33,2.58c.93-.08,1.86-.18,2.8-.3l-1.71,2c.9-1,4.56-2,5.91-2.47-.32.11-.53,1.47-.7,1.76-1.34,2.36-4.82,2.38-6,4.87,3.21-.79,6-3,8.95-4.44,1.45-.73,3-1.25,4.43-1.95,1.08-.51,2.75-2.34,3.89-2.42a7.24,7.24,0,0,0-2.49.37l-2.85,2a21.82,21.82,0,0,1-.5-2.83,39.4,39.4,0,0,1,9.68-2.38c5.05-.62,9.89-3.79,13.61-7.11a26.67,26.67,0,0,0,5-5.1c1.37-2.16,1.65-4.92,3.17-7a12.41,12.41,0,0,1,2.93-2.47,35.54,35.54,0,0,0,5.81-5.69c1.49-1.83,1.83-3.1-.58-3.84-1.87-.57-1.18-2.73-1.74-4.18-.88-2.23-4-5.94-3.05-8.59.79-2.26,4.57.71,5.66,1.3-.05,0,4.37-7.74,7.16-5.2.83.75.21,4.09.21,5.2l-2.28,6,6.27-1.71c1.61,0,4.09-.47,5.53.14-1.18-.51-3.38,1.05-4.32,1.6a21.46,21.46,0,0,0-4.58,3.64c-.19.18-3,3.57-2.62,3.6,1.63.15,3.13-2.68,4.39-3.55,3-2,6.65-2.83,9.84-4.44,3.71-1.88,7.12-4.33,11-5.77a23,23,0,0,1,6.21-1.1c1.12-.08,3.15,0,3.34-1.52s-2.11-3.3-2.33-4.92c-.37-2.57,1.53-4.36,3.16-6.09,1.8-1.91,2.77-1.77,3.16-.83-.39-1.38-1-2.92-1.61-4.55-1-2.71,0-4.16.82-6.74,1-3.13-.73-6.21,1.08-9.26,1.5-2.54,3.14-5.14,3.87-8C527.58,294.19,527.07,291.39,527.43,288.76Zm-4.95,40.95-2.86,1.42c-.29.14-.49,2.72-.57,3.14l1.06.77c1.52-2.47,2.86-4.87,3.06-7,0-.16,0-.35,0-.55a7.56,7.56,0,0,0-.29-1.88A7.91,7.91,0,0,1,522.48,329.71ZM381.61,482.27l.29,2.86,1.71,2.83,1.71,6.85.57,6,1.14,2.86s-1.12-8.72-1.14-8.85c-1.41-11-6.79-21.1-7.61-32.33-.17-2.32-.09-4.68-.09-7l-.57,6.86.57,2.84-.28,6,1.71,2.85-.29,3.13ZM415,402.14l-5.71,3.15-2.85,2.82-2.85.58-1.14.58.85,2.84,8.84-6.25,6-3.16.58-3.13-.86-.58ZM397,415l-.86,2.86-1.71,2.84.29.88,4.56-5.72,1.71-3.15-1.71-.86Zm79.56-54.17-2.85,2-1.14,2,8.84-6.56,2.28-3.41-3.42,2.28Z"
        //     },
        //      {
        //     state : "Utah",
        //     correct : "Salt Lake City",
        //     options : [
        //         "St. George", "Ogden", "Provo", "Park City", "Logan", "Orem"
        //     ],
        //     path : "M475.73,165.31c-44.26-4.5-125.64-17.7-131.68-18.16H344c-5.78,0-4.54-6.22-3.89-9.8,2.42-13.26,4.18-26.66,6.08-40,2.42-17,4.8-34.41,5.94-42.85-38-4.91-75.57-12-113.1-17.75-26.08-4-52-8.81-77.81-13.55C151.7,76.07,90.09,420.89,81.31,469.74c52.31,9.9,170.44,31.59,349.71,53.46C452.64,350.59,472,195.13,475.73,165.31Z"
        // },
        // ]
        states = shuffle(states); //shuffle the states to randomise the order

        // states = states.slice(0, 10); //slice 4 only for dev

        let selected =  this.loadState(states, 0); //loa
        this.setState({
            states : states,
            currentIndex : 0, //reset to the start of the loop,
            selected  : selected, //load the first state.
            options : selected.options,
            incorrect : [], //reset the incorrectly selected answers
            answering : false, //reset the answering hold state
            loopId : Math.random().toString(36).slice(2),
        })        
    }

    makeChoice(opt, optIdx){
        if(opt==this.state.selected.correct){
            
            this.setState({
                answering : true, //reset the answering hold state
            })  

            setTimeout(()=>{
                let nextIndex = this.state.currentIndex+1;
                if(nextIndex>=this.state.states.length){
                    //game complete
                    this.props.onComplete();
                } else {
                    let selected = this.loadState(this.state.states, nextIndex);
    
                    this.setState({
                        currentIndex : nextIndex, //reset to the start of the loop,
                        selected  : selected, //load the first state.
                        options : selected.options,
                        incorrect : [], //reset the incorrectly selected answers
                        answering : false, //reset the answering hold state
                    })  
                }
            }, 300)
            

        } else {
            let incorrect = this.state.incorrect;
            incorrect.push(opt);
            this.setState({
                answering : true,
                incorrect : incorrect
            });
            //button can be marked incorrect now....
            setTimeout(()=>{
                let selected = {...this.state.selected};
                //remove the incorrect answer from the array
                selected.options.splice(optIdx, 1);
                this.setState({
                    selected  : selected,
                    options : selected.options,
                    answering : true, 
                })  
                setTimeout(()=>{
                    this.setState({
                        answering : false, 
                    })  
                }, 300)
            },time);

        }
        
    }

    resetGame(){
        this.setState({
            states : [],
            currentIndex : 0,
            selected : null,
            incorrect : [],
            options : [],
            answering : false
        })
        this.map.reset();
        
    }
    render(){

        const renderState = ()=>{
            if(!this.state.selected) return null;
            return (
                <div className="state-wrap">
                    <p className="state-title">Name the state capital of</p>
                    <p className="current-state" >{this.state.selected.state}</p>
                    <style jsx>{`
                        .current-state {
                            color:#3D5777;
                            font-size:30px!important;
                            line-height: 1em!important;
                        }    
                        .state-title {
                            margin:0!important;
                            line-height: 1.1em!important;
                            color:#504C4A;
                        }
                        @media all and (max-width:599px){
                        
                            .state-wrap {
                                margin-left:-30vw!important;
                                margin-right:-30vw!important;
                            }
                        }
                        
                    `}</style>
                </div>
            )
        }
        const renderButtons = ()=>{

            return this.state.options.map((opt, idx)=>{
                return <AnswerButton 
                            key={this.state.loopId+'_'+this.state.selected.state+opt} 
                            option={opt} 
                            onSelect={()=>{this.makeChoice(opt, idx)}}
                            incorrect={this.state.incorrect}
                            correct={this.state.selected.correct}
                            playPaused={this.state.answering}
                        ></AnswerButton>
                })
        };

        const renderButtonGroup = ()=>{
            if(!this.state.selected) return null;

            return (
                <FlipMove>
                    {renderButtons()}
                </FlipMove>
            )
        }
        return (
            <div className="GameSurface">
                
                
                <div className="wrap">
                
                    <div className="map">
                        {renderState()}
                        <Map selected={this.state.selected} ref={(node)=>this.map=node}></Map>
                    </div>
                    <div className={(this.props.play)?'buttons active': 'buttons'}>
                        {renderButtonGroup()}
                    </div>
                </div>
                <style jsx>{`
                    .GameSurface {
                        min-height: 400px;
                    }
                    .wrap {
                        position: relative!important;
                        overflow: hidden;
                        display: flex;
                       
                    }
                    .map {
                        flex:1;
                    }
                    .buttons {
                        width:50%;
                    }
                    .GameSurface-svg {
                        position: absolute!important;
                        top:0px!important;
                        left:0px!important;
                        right:0px!important;
                        bottom:0px!important;
                    }

                    .stick {
                        cursor: pointer;
                    }
                    @media all and (max-width:599px){
                        .GameSurface {
                            min-height: 00px;
                        }
                        .wrap {
                            display: block;
                        
                        }
                        .map {
                            margin-left:30vw!important;
                            margin-right:30vw!important;
                        }
                        .buttons {
                            width:auto;
                            transition: all 0.3s;
                          
                        }
                        .buttons.active {
                            min-height: 200px;
                        }
                       
                    }

                    
                `}</style>

            </div>
        )
    }
}

GameSurface.propTypes = {
    
}

export default GameSurface;